<template>
    <div :style="theme">
      <layout v-bind:settingsConfig="settingsConfig">
        <div id="spacer"></div>
        <div class="container">
          <div class="box">
            <h2 class="title has-text-centered">{{this.fo_config['text']['booking_title']}}</h2>
            <h3 v-if="this.fo_config['text']['booking_subtitle'] && this.fo_config['text']['booking_title']!= ''" class="has-text-centered" style="color: red;">{{this.fo_config['text']['booking_subtitle']}}</h3>
            <div v-if="this.fo_config['filter'] && (agendas.length > 1 || locations.length > 1 || categories || categories.length > 1)" class="box">
              <h3 class="subtitle has-text-centered">Filtres</h3>
              <template v-for="fConf in this.fo_config['filter']">
                  <template v-if="fConf['targeted_table'] === 'agendas'">
                      <div class="field" v-if="display_agendas && filtered_agendas.length >= fConf['min_to_show']">
                          <label for="select-agenda" class="label">{{fConf['label']}}</label>
                          <div class="control">
                              <div class="select">
                              <select name="" id="select-agenda" @change="changeFilters" v-model="agenda_id" >
                                  <option  v-if="fConf['nullable']" :value="null">
                                    Tous les prestataires ({{
                                        filtered_agendas
                                        .map((agenda) => agenda.name)
                                        .slice(0, 5)
                                        .join(", ")
                                    }}, ...)
                                  </option>
                                  <option v-for="ag in filtered_agendas" :value="ag.agenda_id" :key="ag.agenda_id" >
                                    {{ ag.name }}
                                  </option>
                              </select>
                              </div>
                          </div>
                      </div>
                  </template>

                  <template v-else-if="fConf['targeted_table'] === 'locations'">
                      <div class="field" v-if="locations.length >= fConf['min_to_show']">
                          <label for="select-location" class="label">{{fConf['label']}}</label>
                          <div class="control">
                              <div class="select">
                              <select
                                  name=""
                                  id="select-location"
                                  @change="changeFilters"
                                  v-model="location_id"
                              >
                                  <option v-if="fConf['nullable']" :value="null">Tous les lieux</option>
                                  <option
                                  :value="location.location_id"
                                  v-for="(location, index) in locations"
                                  :key="index"
                                  >
                                  {{ location.name }}
                                  {{
                                      location.address && fConf['show_address'] == '1'
                                      ? `(${renderLocationAddress(location)}, ${location.city})`
                                      : ""
                                  }}
                                  </option>
                              </select>
                              </div>
                          </div>
                      </div>
                  </template>
                  
                  <template v-else-if="fConf['targeted_table'] === 'categories'">
                      <div class="field" v-if="categories && categories.length >= fConf['min_to_show']">
                          <label for="select-location" class="label">{{fConf['label']}}</label>
                          <div v-if="fConf['style'] === 'tag'" class="container-categories-tags">
                              <div v-for="(categorie, index) in filtered_categories" v-on:click="onCategoryTagClicked(categorie.category_id)"
                                   class="category-tag" v-bind:class="{'category-tag-unactive': categorie.category_id != category_id, 'category-tag-active': categorie.category_id == category_id}">
                                  {{ categorie.fo_name || categorie.bo_name }}
                              </div>
                          </div>
                          <div v-else class="control">
                              <div class="select">
                              <select
                                  name=""
                                  id="select-location"
                                  @change="changeFilters"
                                  v-model="category_id"
                              >
                                  <option  v-if="fConf['nullable']" :value="null">
                                  Tous les types ({{
                                      categories
                                      .map(
                                          (categorie) =>
                                          categorie.fo_name || categorie.bo_name
                                      )
                                      .slice(0, 5)
                                      .join(", ")
                                  }}, ...)
                                  </option>
                                  <option
                                  :value="categorie.category_id"
                                  v-for="(categorie, index) in categories"
                                  :key="index"
                                  >
                                  {{ categorie.fo_name || categorie.bo_name }}
                                  </option>
                              </select>
                              </div>
                          </div>
                      </div>
                  </template>
              </template>
            </div>

            <div class="box" v-else-if=" agendas.length > 1 || locations.length > 1 || categories || categories.length > 1 ">
              <h3 class="subtitle has-text-centered">Filtres</h3>
              <div class="field" v-if="display_agendas">
                <label for="select-agenda" class="label">Prestataire</label>
                <div class="control">
                  <div class="select">
                    <select
                      name=""
                      id="select-agenda"
                      @change="changeFilters"
                      v-model="agenda_id"
                    >
                      <option :value="null">
                        Tous les prestataires ({{
                          agendas
                            .map((agenda) => agenda.name)
                            .slice(0, 5)
                            .join(", ")
                        }}, ...)
                      </option>
                      <option
                      v-for="ag in agendas"
                        :value="ag.agenda_id"
                        :key="ag.agenda_id"
                      >
                        {{ ag.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="field" v-if="locations.length > 1">
                <label for="select-location" class="label">Lieu</label>
                <div class="control">
                  <div class="select">
                    <select
                      name=""
                      id="select-location"
                      @change="changeFilters"
                      v-model="location_id"
                    >
                      <option :value="null">Tous les lieux</option>
                      <option
                        :value="location.location_id"
                        v-for="(location, index) in locations"
                        :key="index"
                      >
                        {{ location.name }}
                        {{
                          location.address && fConf['show_address'] == '1'
                            ? `(${renderLocationAddress(location)}, ${location.city})`
                            : ""
                        }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="field" v-if="categories && categories.length > 1">
                <label for="select-location" class="label"
                  >Type de prestation</label
                >
                <div class="control">
                  <div class="select">
                    <select
                      name=""
                      id="select-location"
                      @change="changeFilters"
                      v-model="category_id"
                    >
                      <option :value="null">
                        Tous les types ({{
                          categories
                            .map(
                              (categorie) =>
                                categorie.fo_name || categorie.bo_name
                            )
                            .slice(0, 5)
                            .join(", ")
                        }}, ...)
                      </option>
                      <option
                        :value="categorie.category_id"
                        v-for="(categorie, index) in categories"
                        :key="index"
                      >
                        {{ categorie.fo_name || categorie.bo_name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

            </div>

            <div class="columns is-multiline" v-if="display_prestations">
              <div class=" column is-one-third is-full-mobile is-flex is-flex-direction-column " v-for="(prestation, index) in filtered_prestations" :key="index" >
                <div
                  class=" card is-flex-grow-1 is-flex is-flex-direction-column is-justify-content-space-between " >
                  <div class="card-header">
                    <div class="card-header-title">
                      {{ prestation.fo_name || prestation.bo_name }}
                    </div>
                    <!-- <div class="card-header-icon has-text-success" v-if="isSelected(prestation)" title="Prestation selectionnée">
                                          <i class="fas fa-check"></i>
                                      </div> -->
                    <div
                      class="card-header-icon"
                      v-if="
                        config.prestation_groupe_enable && prestation.is_group
                      "
                      title="Prestation de groupe"
                    >
                      <i class="fas fa-users"></i>
                    </div>
                  </div>
                  <div class="card-content is-flex-grow-1">
                    <div
                      class="is-flex is-align-items-flex-start"
                    >
                      <div class="ressource-content pl-2 is-clearfix">
                        <div class="pt-2" v-if="prestation.image">
                          <img
                            class="ressource-img"
                            :src="getPrestationImagePath(prestation)"
                            alt=""
                          />
                        </div>
                        <p>
                          {{
                            prestation.fo_description || prestation.bo_description
                          }}
                        </p>
                        <p
                          v-if="config.display_price && prestation.display_price"
                        >
                          <b>Prix :</b> {{ prestation.is_group && prestation.allow_subgroup ? prestation.price*prestation.group_size : prestation.price}}{{ config.money }}
                        </p>
                        <p v-if="config.display_duration && prestation.display_duration">
                          <b>Durée :</b> {{ prestation.duration }} minutes
                        </p>
                        <div
                          v-if="prestation.is_group && prestation.allow_subgroup"
                        >
                          <div class="field is-flex is-align-items-center">
                            <label class="label is-flex-grow-2">Nombre de participants</label>
                            <div class="control group-size-input is-flex-grow-1">
                              <input
                                :disabled="!isSelected(prestation)"
                                class="input"
                                type="number"
                                min="1"
                                :max="prestation.max_nbr_clients"
                                v-model="prestation.group_size"
                                @change="setGroupSize($event, prestation)"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="card-footer">
                    <div
                      class="card-footer-item is-clickable selected-prestation"
                      v-if="isSelected(prestation)"
                      @click="removePrestation(prestation)"
                    >
                      <button class="is-flex-grow-1 footer-button has-text-white">
                        Retirer
                      </button>
                    </div>
                    <div
                      class="card-footer-item disabled"
                      v-else-if="!isSelectable(prestation)"
                    >
                      <button class="is-flex-grow-1 footer-button disabled">
                        Sélectionner
                      </button>
                    </div>
                    <div
                      class="card-footer-item is-clickable"
                      v-else
                      @click="addPrestation(prestation)"
                    >
                      <button class="is-flex-grow-1 footer-button has-text-info">
                        Sélectionner
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

              <p v-if="config.prestation_groupe_enable" class="is-italic">
                Les prestations marquées d'un
                <i class="fas fa-users"></i> indiquent une prestation de groupe.
              </p>
              <p v-if="config.prestation_groupe_enable && config.prestation_combo_enable" class="is-italic">
                Vous pouvez sélectionner plusieurs prestations, cependant les
                prestations de groupe ne peuvent pas être combinées avec d'autre
                prestations.
              </p>

            <div class="container">
              <div id="form-buttons" v-if="selected_prestations.length > 0">
                <button class="button mx-3 my-2" @click="removeAllPrestation">
                  Annuler
                </button>
                <button id="btn-select-presta" :title="this.can_choose_slot?'':'Nombre de participants hors de l\'intervalle permis'" 
                        @click="save" :disabled="!this.can_choose_slot" class="button mx-3 my-2 is-primary shinny-effect">
                        {{settingsConfig["AUTO_BOOKING"] == 1 ? "Réserver" : "Choisir un créneau"}}
                </button>
              </div>
            </div>
          </div>
        </div>
      </layout>
    </div>
  </template>

  <script>
  import Layout from "../Layout.vue";
  import { toast } from "bulma-toast";
  export default {
    components: { Layout },
    remember: ["agenda_id", "location_id", "category_id"],
    computed: {
      cdn_subdomain() {
        return this.$page.props.cdn_subdomain;
      },
      config() {
        return this.$page.props.config;
      },
      display_agendas() {
        if (this.config.force_fo_agenda_selection) return true;

        if (!this.config.choose_presta_on_calendar) return false;

        return true;
      },
      display_prestations() {
        if (this.config.force_fo_agenda_selection && !this.agenda_id)
          return false;

        return true;
      },
      client_rdvs() {
        return this.$page.props.client_rdvs;
      },
      // TODO prendre le cas du nullables : tous les agendas selectionnés
      filtered_agendas(){
          let res = this.agendas.filter(agenda => agenda.location_id == this.location_id);
          this.agenda_id = res.length > 0 ? res[0].agenda_id : null;
          return res;
      },
      // TODO prendre le cas du nullables : tous les categories selectionnées
      filtered_categories(){
          this.category_id = null;
          let prestations = this.display_agendas ? this.prestations.filter(prestation => prestation.agendas.find(agenda => agenda.agenda_id == this.agenda_id)) : this.getPrestaionsByLocation(this.location_id,this.prestations);
          let res = this.categories.filter(category => {
              for (const presta of prestations) {
                  if(presta.categories.find(cat => cat.category_id == category.category_id)) return true;
              }
              return false;
          });
          // Si il n'y a que la catégorie "Sans catégorie" ne pas la retourner
          if(res && res.length < 2) return [];
          return res;
      },
      filtered_prestations(){
          let prestations = [];
          if((this.display_agendas && this.agenda_id) || (!this.display_agendas)){
            let filtered_categories = this.filtered_categories;
            // Si il y a une catégorie sélectionnée ou aucune n'existe
            if(this.category_id || (!this.category_id && filtered_categories.length < 1)){
              prestations = this.prestations.filter(presta => {
                presta.group_size = presta.group_size ?? 0;
                // Si la prestation appartient à l'agenda sélectionné
                
                let has_agenda_id = presta.agendas.find(agenda => agenda.agenda_id == this.agenda_id);
                // Si la prestation appartient à la catégorie sélectionnée
                let has_category_id = filtered_categories.length > 0 ? presta.categories.find(category => category.category_id == this.category_id) : true; // Par défaut appartient à la catégorie si aucune n'existe
                // Sélectionner la prestation si appartient à l'agenda et à la catégorie sélectionnée
                  let res = this.display_agendas && has_category_id && has_agenda_id || !this.display_agendas && has_category_id;
                  return res;
              });
            }
          }
          prestations.sort((prev,next) => prev.position - next.position);
          return prestations;
      },
      theme(){
          return this.fo_config['theme'];
      },
      can_choose_slot(){
        return this.subgroup_in_range;
      },
      subgroup_in_range(){
        if(this.selected_prestations.length != 1 || !this.selected_prestations[0].is_group || !this.selected_prestations[0].allow_subgroup){
          return true;
        }
        let presta = this.selected_prestations[0];
        if(presta.max_nbr_clients < presta.group_size) return false;
        if(presta.allow_min_subgroup && presta.min_nbr_subgroup > presta.group_size) return false;
        if(presta.allow_max_subgroup && presta.max_nbr_subgroup < presta.group_size) return false;
        return true;
      }
    },

    name: "Ressources",
    props: ["agendas", "prestations", "locations", 'fo_config', "settingsConfig"],
    data() {
      return {
      //   filtered_agendas: [],
        agenda_id: null,
        category_id: null,
        is_categories_sorted: false,
        categories: [],
        location_id: null,
        prestations_to_show: [],
        selected_prestations: [],
      };
    },
    methods: {
      addPrestation(prestation) {
        if (this.isSelected(prestation)) return false;
        if (this.config.prestation_groupe_enable && prestation.is_group)
          this.selected_prestations = [];
        if (
          prestation.is_group &&
          prestation.allow_subgroup &&
          !prestation.group_size
        )
          prestation.group_size = 1;
        this.selected_prestations.push(prestation);
      },
      getPrestationImagePath(prestation) {
        let host = window.location.host.split(".");
        if (!host[1]) return false;
        let subdomain = host.shift();
        return (
          window.location.protocol +
          "//" +
          this.cdn_subdomain +
          "." +
          host.join(".") +
          "/datas/" +
          subdomain +
          "/images/prestations/" +
          prestation.image
        );
      },
      isSelectable(prestation) {
        if (this.selected_prestations.length === 0) return true;
        if (!this.config.prestation_combo_enable) return false;
        if (prestation.is_group) return false;
        if (this.selected_prestations[0].is_group) return false;
        return true;
      },
      isSelected(prestation) {
        return this.selected_prestations.find(
          (presta) => prestation.prestation_id == presta.prestation_id
        );
      },
      parseUrl() {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("agenda_id") && parseInt(urlParams.get("agenda_id")))
          this.agenda_id = urlParams.get("agenda_id");
        if (
          urlParams.get("location_id") &&
          parseInt(urlParams.get("location_id"))
        )
          this.location_id = urlParams.get("location_id");
        if (
          urlParams.get("category_id") &&
          parseInt(urlParams.get("category_id"))
        )
          this.category_id = urlParams.get("category_id");
      },
      removeAllPrestation() {
        this.selected_prestations = [];
      },
      removePrestation(prestation) {
        this.selected_prestations = this.selected_prestations.filter(
          (presta) => prestation.prestation_id != presta.prestation_id
        );
      },
      renderLocationAddress(location) {
        if (!location.address) return ''
        let localisation_regex = /((\-?|\+?)?\d+(\.\d+)?),\s*((\-?|\+?)?\d+(\.\d+)?)/
        return location.address.split(' ').filter(elt => !elt.match(localisation_regex)).join(' ')
      },
      save() {
        if (this.config.force_fo_agenda_selection && !this.agenda_id) {
          return toast({
            message:
              "Le choix du prestataire est obligatoire pour passer à l'étape suivante.",
            type: "is-warning",
            duration: 4000,
            pauseOnHover: true,
          });
        }

        if (this.selected_prestations.length === 0) {
          return toast({
            message: "Merci de choisir au moins une prestation.",
            type: "is-warning",
            duration: 4000,
            pauseOnHover: true,
          });
        }

        let query = {};
        query.prestation_id = this.selected_prestations.map(
          (prestation) => {
              // Calcul du prix
              query.price = 0;
              query.price += prestation.price;
              return prestation.prestation_id
          }
        );
        if (this.location_id) query.location_id = this.location_id;
        if (this.agenda_id) query.agenda_id = this.agenda_id;

        if (this.selected_prestations.find((prestation) => prestation.is_group)) {
          if (this.selected_prestations.length > 1) {
            return toast({
              message:
                "Impossible de combiner les prestations de groupe avec d'autre prestations.",
              type: "is-danger",
              duration: 4000,
              pauseOnHover: true,
            });
          }
          let prestation = this.selected_prestations[0];
          if (!prestation.allow_subgroup) query.group_size = 1;
          else query.group_size = prestation.group_size || 1;
          query.price = prestation.price*query.group_size;
        }
        let query_string = new URLSearchParams(query).toString();
        let route = "/times";
        if (query_string) route += "?" + query_string;
        this.$inertia.get(route);
      },
      setCategories() {
          this.categories = [];
          let categories = this.prestations.map((prestation) => prestation.categories).flat();
          for (let categorie of categories) {
                  if (!this.categories.find((cat) => cat.category_id == categorie.category_id))
                  this.categories.push(categorie);
          }
      },
      setPrestasWithoutCategory(){
          for (let i = 0; i < this.prestations.length; i++) {
              if(this.prestations[i].categories.length === 0){
                  this.prestations[i].categories.push({
                      bo_description: "",
                      bo_name: "",
                      category_id: -1,
                      color: null,
                      enabled: null,
                      fo_description: "",
                      fo_name: "Autres",
                      image: null,
                      pivot: null,
                      position: null
                  })
              }
          }
      },
      setDefaultAgenda() {
        if (this.client_rdvs.length === 0) return null;

        let orderedRdvs = this.client_rdvs.sort(
          (a, b) =>
            new Date(a.start_date).getTime() < new Date(b.start_date).getTime()
        );
        let last_rdv = orderedRdvs[0];
        this.agenda_id = last_rdv.agenda_id;
      },
      setGroupSize(e, prestation) {
        let group_size = e.target.value;
        let selected_prestation = this.selected_prestations.find(
          (p) => p.prestation_id == prestation.prestation_id
        );
        selected_prestation.group_size = group_size;
      },
      setPrestations() {
        let prestations = this.prestations;
        let query = {};
        if (this.agenda_id) {
          prestations = prestations.filter((prestation) =>
            prestation.agendas.find(
              (agenda) => agenda.agenda_id == this.agenda_id
            )
          );
          query.agenda_id = this.agenda_id;
        }
        if (this.location_id) {
          prestations = prestations.filter((prestation) =>
            prestation.agendas.find(
              (agenda) => agenda.location_id == this.location_id
            )
          );
          query.location_id = this.location_id;
        }
        if (this.category_id) {
          prestations = prestations.filter((prestation) =>
            prestation.categories.find(
              (category) => category.category_id == this.category_id
            )
          );
          query.category_id = this.category_id;
        }
        this.prestations_to_show = prestations;
      },

      changeFilters() {
        let query = {};
        if (this.agenda_id) {
          query.agenda_id = this.agenda_id;
        }
        if (this.location_id) {
          query.location_id = this.location_id;
        }
        if (this.category_id) {
          query.category_id = this.category_id;
        }
      },
      onCategoryTagClicked(id){
          this.category_id = id;
          this.changeFilters();
      },

      getPrestaionsByLocation(location_id, prestations){
          let filtered = [];
          for (let presta of prestations) {
              let agenda = presta.agendas.find(item => item.location_id === location_id);
              if(agenda){
                  filtered.push(presta);
              }
          }
          return filtered;
      },
      setBodyStyle(){
          document.body.style.backgroundColor = this.theme['--body-bg-color'];
      }
    },

    beforeMount(){
      this.setPrestasWithoutCategory();
    },

    mounted() {
      this.setBodyStyle();
      if(this.fo_config){
          this.fo_config["filter"].sort((prev, next) => prev.position - next.position);
      }
      this.setCategories();
      this.parseUrl();
      this.setPrestations();
      if (this.locations.length > 0) this.location_id = this.locations[0].location_id;
    },
  };
  </script>

  <style scoped>
  .card-header {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    overflow: hidden;
  }
  .card,
  .card-footer {
    border-bottom-left-radius: 20px;
    border-bottom-right-radius: 20px;
    overflow: hidden;
  }
  .card-footer {
      background-color: var(--card-footer-bg-color);
  }
  .card-footer button {
      color: var(--card-footer-text-color) !important;
  }

  .selected-prestation {
    background-color: var(--card-footer-selected-bg-color);
  }

  .selected-prestation button {
    color: var(--card-footer-selected-text-color) !important;
  }

  /* .selected-prestation:hover {
    background-color: var(--card-footer-selected-bg-color-hover);
  } */

  .card-footer-item:hover {
    background-color: var(--card-footer-bg-color-hover);
  }

  .selected-prestation:hover {
    background-color: var(--card-footer-selected-bg-color-hover);
  }
  .card-footer-item.disabled:hover {
    background-color: var(--card-footer-bg-disabled-color);
  }

  .card-content {
    max-height: 300px;
    overflow: auto;
    text-overflow: ellipsis;
    background-color: var(--card-content-bg-color);
  }
  .card-header-title,
  .card-header-icon {
    background-color: var(--card-header-bg-color);
    color: var(--card-header-text-color);
  }

  #btn-select-presta {
      background-color: var(--btn-select-presta-bg-color);
      color: var(--btn-select-presta-text-color);
  }

  /* .card-footer-item:hover {
    background-color: #fafafa;
  }
  .card-footer-item.disabled:hover {
    background-color: #fff;
  } */
  .select,
  .select > select {
    width: 100%;
  }
  .is-flex-grow-1.footer-button {
    background-color: inherit;
    border: 0;
    color: #3e8ed0;
    cursor: pointer;
  }
  .is-flex-grow-1.footer-button.disabled {
    color: #999;
    cursor: not-allowed;
  }
  .group-size-input {
    flex-basis: 82px;
  }
  #placeholder-message {
    color: #888;
  }
  #form-buttons {
    background-color: #fff;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    box-shadow: 0px 10px 30px;
    position: fixed;
    bottom: 0px;
    left: 0px;
    width: 100%;
    text-align: right;
  }

  .ressource-img {
    max-width: 100px;
    float: left;
    margin-right: 5px;
  }
  .ressource-content {
    width: 100%;
  }

  .container-categories-tags{
      display: grid;
      grid-template-columns: auto auto auto;
  }

      .category-tag{
          cursor: pointer;
          align-items: center;
          border-radius: 4px;
          color: white;
          display: inline-flex;
          font-size: 1rem;
          justify-content: center;
          line-height: 1.5;
          margin: 0.5rem;
          padding: 1rem;
      }
      /* .category-tag:active{
          background-color: #6c6387;
      } */
      .category-tag-active{
          /* background-color: #6c6387; */
          background-color: var(--btn-primary-text-color);
          color: var(--btn-primary-bg-color);
          border: 1px solid var(--btn-primary-bg-color);
      }

      .category-tag-unactive{
          background-color: var(--btn-primary-bg-color);
          color: var(--btn-primary-text-color);
      }

      @media (max-width: 991px) {
          .container-categories-tags{
              display: grid;
              grid-template-columns: auto auto;
          }
      }

      @media (max-width: 400px) {
          .container-categories-tags{
              display: grid;
              grid-template-columns: auto;
          }
      }
  </style>
